// Every translation namespace for this language. Add a page's file here and in the other language's index.
import common from './common.json';
import layout from './layout.json';
import scanner from './scanner.json';
import sell from './sell.json';
import server from './server.json';
import transfer from './transfer.json';
import bulkUpload from './bulkUpload.json';
import refunds from './refunds.json';
import authors from './authors.json';
import books from './books.json';
import bookBundles from './bookBundles.json';
import warehouses from './warehouses.json';
import shipping from './shipping.json';
import taxRates from './taxRates.json';
import bookOrders from './bookOrders.json';
import serverTicketOps from './serverTicketOps.json';
import serverBookCatalog from './serverBookCatalog.json';
import serverBookOrders from './serverBookOrders.json';

const resources = {
  common,
  layout,
  scanner,
  sell,
  server,
  transfer,
  bulkUpload,
  refunds,
  authors,
  books,
  bookBundles,
  warehouses,
  shipping,
  taxRates,
  bookOrders,
  serverTicketOps,
  serverBookCatalog,
  serverBookOrders,
};

export default resources;
